import { deepPurple } from '@mui/material/colors';
import { Box, Card, Grid, Stack, useTheme, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

export const DetailStudentManageFunction = () => {
  const theme = useTheme();
  const deepPurpleColor = deepPurple.A200;

  const smDown = useResponsive('down', 'sm');
  const padding = () => {
    if (smDown) {
      return 2;
    }
    return 3;
  };
  return (
    <Stack mb={smDown ? 5 : 10}>
      <Stack my={5} spacing={2} alignItems="center">
        <Typography
          fontFamily='"Shantell Sans Light", sans-serif'
          sx={{ color: deepPurpleColor }}
          fontSize={18}
          align="center"
          fontWeight="medium"
        >
          Phần mềm quản lý trung tâm thế hệ mới
        </Typography>
        <Typography variant="h2" align="center">
          Quản lý học viên hiệu quả
        </Typography>
        <Stack>
          <Typography variant="body1" align="center" maxWidth={808}>
            Lưu trữ hồ sơ học viên, lịch học, điểm danh, báo cáo học tập và công nợ trên CenterUp.
            Phần mềm quản lý trung tâm giúp kết nối thông tin học viên xuyên suốt toàn hệ thống.
          </Typography>
        </Stack>
      </Stack>
      <Stack alignSelf="center" maxWidth={1150}>
        <Grid container justifySelf="center" spacing={4} alignItems="stretch">
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
                position: 'relative',
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack zIndex={2} px={padding} pt={padding}>
                  <Typography variant="h5">Quản lý hồ sơ học viên tập trung</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Lưu trữ tập trung toàn bộ thông tin học viên: hồ sơ cá nhân, lịch sử học, lớp
                    đang theo học, người phụ huynh, liên hệ, ghi chú đặc biệt.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="employee-detail"
                    src="/assets/sub-pages/manage/student/manage.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding}>
                  <Typography variant="h5">Lịch sử lớp học</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Theo dõi lịch sử lớp học. Quản lý việc chuyển lớp, học bù. Tự động đồng bộ với
                    CenterUp LMS để xác định tiến độ học tập.
                  </Typography>
                </Stack>{' '}
                <Stack>
                  <Box
                    alignSelf="flex-end"
                    alt="class-dashboard"
                    component="img"
                    width="100%"
                    src="/assets/sub-pages/manage/student/history.png"
                    zIndex={2}
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding}>
                  <Typography variant="h5">Báo cáo điểm danh tổng quan</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Thống kê chuyên cần theo tuần/tháng, theo từng lớp, từng học viên. Cảnh báo nếu
                    số học viên nghỉ quá tỉ lệ quy định.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-task"
                    src="/assets/sub-pages/manage/student/attendance-report.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Báo cáo bài tập của từng học viên</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Báo cáo trạng thái làm bài và kết quả theo lớp, từng học viên, theo từng bài
                    tập/đề thi – dễ dàng đánh giá chất lượng học tập và cải thiện giảng dạy.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/manage/student/student-report.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Báo cáo học phí & công nợ</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Theo dõi chi tiết số tiền học viên đã đóng, còn nợ, được giảm, hoặc được hoàn.
                    Liên kết trực tiếp với module tài chính để cập nhật tự động.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/manage/student/fee-report.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Lịch sử tương tác và chăm sóc học viên</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Ghi nhận toàn bộ lịch sử trao đổi với học viên/phụ huynh: cuộc gọi, tin nhắn,
                    email, CSKH sau buổi học, phản hồi khảo sát.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/manage/student/log.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
};
